const COMPONENT_NAME = "cookieSettings";
const TRANSCEND_BUTTON_ID = "transcend-btn";
const ONETRUST_BUTTON_ID = "ot-sdk-btn";
const ONETRUST_SCRIPT_SRC = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
const ONETRUST_SCRIPT_ID = "2653cf4b-5c84-40d7-a99b-fa6e1592503b-test";
const ONETRUST_BUTTON_CLASS = "ot-sdk-show-settings";
const DEV_KEY_ENABLE_TRANSCEND_COOKIE_MONITORING = "enable_transcend_cookie_monitoring";
export {
  COMPONENT_NAME,
  DEV_KEY_ENABLE_TRANSCEND_COOKIE_MONITORING,
  ONETRUST_BUTTON_CLASS,
  ONETRUST_BUTTON_ID,
  ONETRUST_SCRIPT_ID,
  ONETRUST_SCRIPT_SRC,
  TRANSCEND_BUTTON_ID
};
